import { PageRouteBuilder } from "@common/route/page-route-builder";
import { ResetPasswordPageComponent } from "./reset-password-page.component";

export const resetPasswordPageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-reset-password-page", ResetPasswordPageComponent)
    .atUrl("/account/reset-password")
    .requiresLogin(false)
    .requiresAnonymous(false)
    .build();
